export default "__VITE_ASSET__3dba0295__"